// @ts-expect-error no types for one-xp-sdk
import { initialize } from '@americanexpress/one-xp-sdk';
import { Context, createContext } from 'react';

let sdkClient: any = null;
try {
    sdkClient = initialize({
        applicationId: '600002165',
        oneXPFaasURL: process.env.REACT_APP_ONEXP_FAAS_URL,
        fetchOpts: { credentials: 'include' }
    });
} catch (e) {
    const err = e as Error;
    if (err?.message.startsWith('Invalid param oneXPFaasURL')) {
        console.log('Error initializing OneXP SDK', e);
    } else throw e;
}

const OneXPContext: Context<any> = createContext(sdkClient);

export { sdkClient, OneXPContext };
